import { render, staticRenderFns } from "./MyBanks.vue?vue&type=template&id=383e694b"
import script from "./MyBanks.vue?vue&type=script&lang=js"
export * from "./MyBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports